import React, { LegacyRef } from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

const FluentWeatherMoon = React.forwardRef<
  SVGElement,
  { fillColor?: string } & SvgProps
>(({ fillColor = 'currentColor', ...props }, ref) => (
  <Svg
    ref={ref as LegacyRef<Svg>}
    width={24}
    height={24}
    fill='none'
    viewBox='0 0 24 24'
    {...props}
  >
    <Path
      d='M20.026 17.001c-2.762 4.784-8.879 6.423-13.663 3.661A9.965 9.965 0 0 1 3.13 17.68a.75.75 0 0 1 .365-1.132c3.767-1.348 5.785-2.91 6.956-5.146 1.232-2.353 1.551-4.93.689-8.463a.75.75 0 0 1 .769-.927 9.961 9.961 0 0 1 4.457 1.327c4.784 2.762 6.423 8.879 3.66 13.662Z'
      fill={fillColor}
    />
  </Svg>
))

export default FluentWeatherMoon
